module.exports = __webpack_public_path__ + "static/img/far3_active.e4a9f7a3.png";